module.exports = __webpack_public_path__ + "img/hannah-event-banner-2.d3e01114.png";